"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _OptionsBase = _interopRequireDefault(require("./OptionsBase"));

var _RadioBase = _interopRequireDefault(require("./RadioBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const RadioWidget = (_ref) => {
  let id = _ref.id,
      value = _ref.value,
      options = _ref.options,
      required = _ref.required,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      autofocus = _ref.autofocus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "value", "options", "required", "disabled", "readonly", "autofocus", "onBlur", "onFocus", "onChange"]);

  // Generating a unique field name to identify this set of radio buttons
  const name = Math.random().toString();
  const enumOptions = options.enumOptions,
        enumDisabled = options.enumDisabled,
        inline = options.inline; // checked={checked} has been moved above name={name}, As mentioned in #349;
  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.

  const handleChange = event => {
    onChange && onChange(event.target.value);
  };

  const label = options.title || props.title || props.label || null;
  const radioOptions = enumOptions.map((option, index) => {
    const checked = value && value.toString() && option.value.toString() === value.toString() || false;
    const itemId = id + "_" + index;
    const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    return {
      id: itemId,
      name: name,
      disabled: disabled || itemDisabled || readonly,
      label: option.label,
      value: option.value,
      checked: checked,
      onChange: handleChange
    };
  });
  return _react.default.createElement(_OptionsBase.default, _extends({
    label: label
  }, options), radioOptions.map((option, index) => {
    return _react.default.createElement(_RadioBase.default, _extends({}, option, {
      key: index
    }));
  }));
};

RadioWidget.defaultProps = {
  autofocus: false
};
RadioWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: _propTypes.default.object.isRequired,
  id: _propTypes.default.string.isRequired,
  options: _propTypes.default.shape({
    enumOptions: _propTypes.default.array,
    inline: _propTypes.default.bool
  }).isRequired,
  value: _propTypes.default.any,
  required: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  autofocus: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : {};
var _default = RadioWidget;
exports.default = _default;
module.exports = exports.default;